export default "__VITE_ASSET__DdVEuqgL__"